import { SendGiftOccasionTemplate } from '@hero/components';

export default function SendGiftOccasionsPage() {
  return <SendGiftOccasionTemplate />;
}
